// IMPORT JQUERY
window.jQuery = require('jquery');
window.$ = global.jQuery;

import barba from '@barba/core';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { SplitText } from 'gsap/SplitText';
import { CSSRulePlugin } from 'gsap/CSSRulePlugin';

// JQUERY NOCONFLICT
var $ = jQuery.noConflict();

// IMPORT WAYPOINTS
require('waypoints/lib/jquery.waypoints');

// IMPORT GREENSOCK - GSAP LIBRARY
// import { gsap } from "lib/gsap";
// GREENSOCK - GSAP LIBRARY
gsap.registerPlugin(SplitText, CSSRulePlugin, ScrollTrigger);

gsap.config(
    {
        autoSleep: 60,
        force3D: false,
        nullTargetWarn: false,
        trialWarn: false,
        units: { left: "%", top: "%", rotation: "rad" }
    }
);

// SCRIPTS
(function ($) {

    // TOOGLE ANIMATION
    $('#toogle-animation').on(
        'click', function () {
            $(this).toggleClass("open");
            $('#site-navigation').toggleClass("closed");
            $('#site-navigation-mobile').toggleClass("open");
            $('body').toggleClass("body-hidden");

        }
    );

    // $('.entry-title').addClass("move-it");
    // $('.site-title').addClass("move-it");
    // $('.site-title-mobile').addClass("move-it"); 

    const tl = gsap.timeline({ repeat: 0 }), // -1 will repeat
        split = new SplitText(".move-it", { type: "chars, words" }),
        chars = split.chars;

    // tl.set(chars, { color: "random([#6fb936, #f38630, #989898, pink])" }, 2);  

    tl.from(
        chars, {
        opacity: 0,
        duration: .1,
        stagger: .1,
    }
    );

    tl.to(
        chars, {
        duration: .5,
        opacity: 1,
        stagger: 0.05,
        ease: "power4.easeIn",
    }
    );
})(jQuery);


$(function () {
    $("#stars").addClass("stars animated fadeIn delay-02s");
});

$(window).on('blur', function () {
    setTimeout(function () {
        $("#stars").removeClass("fadeIn").addClass("fadeOut");
    }, 300);
});

$(window).on('blur', function () {
    setTimeout(function () {
        $("#stars").removeClass("fadeIn").addClass("fadeOut");
    }, 300);
});

// WAYPOINTS trigger for step child elements animation
// Adds the animation classes once, then destroys each waypoint so it does not retrigger on scroll.
document.addEventListener('DOMContentLoaded', function () {
    var $ = jQuery.noConflict();

    $('.step-up').css('opacity', 0);
    $('.step-up').waypoint(
        function (direction) {
            if (direction === 'down') {
                $(this.element).addClass('animated step').css('opacity', 1);
                this.destroy();
            }
        }, {
        offset: '80%'
    }
    );
});


var cwhPanelTriggers = [];
var cwhPanelTweens = [];
var cwhPanelInitFrame = null;
var cwhPanelRefreshTimer = null;
var cwhHorizontalGalleryTweens = [];
var cwhHorizontalGalleryRefreshHandlers = [];

function setPageWipeDestination(data) {
  var pathParts = data.next.url.path.split('/').filter(Boolean);

  document.body.dataset.cwhPageWipe = pathParts.pop() || 'home';
}

function syncBodyClasses(data) {
  var nextDocument = new DOMParser().parseFromString(data.next.html, 'text/html');

  document.body.className = nextDocument.body.className;
}

function syncWordPressInlineStyles(data) {
  var nextDocument = new DOMParser().parseFromString(data.next.html, 'text/html');
  var selector = 'style[id$="-inline-css"]';
  var currentStyles = document.head.querySelectorAll(selector);
  var marker = document.createComment('wordpress-inline-styles');
  var anchor = currentStyles[0] || document.head.querySelector('link[rel="stylesheet"]');

  document.head.insertBefore(marker, anchor || null);

  currentStyles.forEach(function (style) {
    style.remove();
  });

  nextDocument.head.querySelectorAll(selector).forEach(function (style) {
    document.head.insertBefore(style.cloneNode(true), marker);
  });

  marker.remove();
}

function cleanupPinnedPanels() {
  if (cwhPanelInitFrame) {
    cancelAnimationFrame(cwhPanelInitFrame);
    cwhPanelInitFrame = null;
  }

  if (cwhPanelRefreshTimer) {
    clearTimeout(cwhPanelRefreshTimer);
    cwhPanelRefreshTimer = null;
  }

  cwhPanelTweens.forEach(function (tween) {
    tween.kill();
  });

  cwhPanelTriggers.forEach(function (trigger) {
    trigger.kill();
  });

  gsap.set('.cwh-panel', { clearProps: 'opacity,transform' });

  cwhPanelTweens = [];
  cwhPanelTriggers = [];
}

function cleanupHorizontalGalleries() {
  cwhHorizontalGalleryRefreshHandlers.forEach(function (refresh) {
    ScrollTrigger.removeEventListener('refreshInit', refresh);
  });

  cwhHorizontalGalleryTweens.forEach(function (tween) {
    if (tween.scrollTrigger) {
      tween.scrollTrigger.kill();
    }

    tween.kill();
  });

  gsap.set('.cwh-horizontal-gallery__track', { clearProps: 'transform' });

  cwhHorizontalGalleryTweens = [];
  cwhHorizontalGalleryRefreshHandlers = [];
}

function initHorizontalGalleries() {
  cleanupHorizontalGalleries();

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return;
  }

  gsap.utils.toArray('.cwh-horizontal-gallery').forEach(function (gallery) {
    var track = gallery.querySelector('.cwh-horizontal-gallery__track');
    var scrollLength = 0;

    if (!track) {
      return;
    }

    function refresh() {
      scrollLength = Math.max(0, track.scrollWidth - gallery.clientWidth);
    }

    refresh();

    if (!scrollLength) {
      return;
    }

    ScrollTrigger.addEventListener('refreshInit', refresh);
    cwhHorizontalGalleryRefreshHandlers.push(refresh);

    cwhHorizontalGalleryTweens.push(
      gsap.to(track, {
        x: function () {
          return -scrollLength;
        },
        ease: 'none',
        scrollTrigger: {
          trigger: gallery,
          start: 'top top',
          end: function () {
            return '+=' + scrollLength;
          },
          pin: true,
          scrub: true,
          invalidateOnRefresh: true
        }
      })
    );
  });

  ScrollTrigger.refresh();
}

function schedulePinnedPanels() {
  cleanupPinnedPanels();

  cwhPanelInitFrame = requestAnimationFrame(function () {
    cwhPanelInitFrame = requestAnimationFrame(function () {
      cwhPanelInitFrame = null;
      initPinnedPanels();

      cwhPanelRefreshTimer = setTimeout(function () {
        cwhPanelRefreshTimer = null;
        ScrollTrigger.refresh();
      }, 150);
    });
  });
}

function initPinnedPanels() {
  var panels = gsap.utils.toArray('.cwh-panel');

  cleanupPinnedPanels();

  if (!panels.length || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return;
  }

  gsap.set(panels, { opacity: 1, scale: 1 });

  panels.forEach(function (panel, index) {
    cwhPanelTriggers.push(
      ScrollTrigger.create({
        trigger: panel,
        start: function () {
          return panel.offsetHeight < window.innerHeight ? 'top top' : 'bottom bottom';
        },
        pin: true,
        pinSpacing: false,
        invalidateOnRefresh: true
      })
    );

    if (index === panels.length - 1) {
      return;
    }

    var tween = gsap.to(panel, {
      scale: 0.94,
      ease: 'none',
      scrollTrigger: {
        trigger: panels[index + 1],
        start: 'top bottom',
        end: 'top top',
        scrub: true,
        invalidateOnRefresh: true
      }
    });

    cwhPanelTweens.push(tween);
    cwhPanelTriggers.push(tween.scrollTrigger);
  });

  ScrollTrigger.refresh();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function () {
    schedulePinnedPanels();
    initHorizontalGalleries();
  });
} else {
  schedulePinnedPanels();
  initHorizontalGalleries();
}

if ('scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual';
}

barba.init({
  transitions: [
    {
      name: 'pseudo-skew',
      async leave(data) {
        setPageWipeDestination(data);
        document.body.classList.add('barba-transitioning');
        await new Promise(resolve => setTimeout(resolve, 600));

      },
      enter() {
        document.body.classList.remove('barba-transitioning');
      }
    }
  ]
});

barba.hooks.beforeLeave(cleanupPinnedPanels);
barba.hooks.beforeLeave(cleanupHorizontalGalleries);

barba.hooks.afterEnter((data) => {
  syncBodyClasses(data);
  syncWordPressInlineStyles(data);
  window.scrollTo(0, 0);
  ScrollTrigger.clearScrollMemory();
  schedulePinnedPanels();
  initHorizontalGalleries();
});
